// Map of readable values to panel codes (POST -> GET)
export const ZONE_TYPE_MAP = {
  BLANK: '--',
  NIGHT: 'NT',
  DAY: 'DY',
  EXIT: 'EX',
  FIRE: 'FI',
  SUPERVISORY: 'SV',
  FIRE_VERIFY: 'FV',
  PANIC: 'PN',
  ARMING: 'AR',
  AUXILIARY1: 'A1',
  AUXILIARY2: 'A2',
  EMERGENCY: 'EM',
  INSTANT: 'IN',
  CARBONE_MONOXIDE: 'CO',
  DOOR_BELL: 'DB',
};

export const MESSAGE_TYPE_MAP = {
  NONE: '--',
  ALARM: 'A',
  TROUBLE: 'T',
  LOCAL: 'L',
  DOOR_PROPPED_OPEN: 'D',
  SENSOR_RESET: 'S',
  CANCEL_AMBUSH: 'C',
};

export const OUTPUT_ACTION_MAP = {
  NONE: '-',
  PULSE: 'P',
  STEADY: 'S',
  MOMENTARY: 'M',
  FOLLOW: 'F',
};

export const WIRELESS_CONTACT_MAP = {
  EXTERNAL: '0',
  INTERNAL: '1',
};

export const SUPERVISION_MAP = {
  NONE: '0',
  '3_MINUTES': '1',
  '60_MINUTES': '2',
  '240_MINUTES': '3',
};

export const PIR_PULSE_COUNT_MAP = {
  '2': '2',
  '4': '4',
};

export const PIR_SENSITIVITY_MAP = {
  LOW: 'L',
  HIGH: 'H',
};

export const PET_IMMUNITY_MAP = {
  ON: 'N',
  OFF: 'F',
};

export const CHIME_SONG_MAP = {
  OFF: '0',
  DOOR_BELL: '1',
  DESCEND: '2',
  ASCEND: '3',
};

// Reverse mapping (GET -> POST) - panel codes to readable values
export const ZONE_TYPE_REVERSE_MAP = Object.fromEntries(
  Object.entries(ZONE_TYPE_MAP).map(([k, v]) => [v, k])
);

export const MESSAGE_TYPE_REVERSE_MAP = Object.fromEntries(
  Object.entries(MESSAGE_TYPE_MAP).map(([k, v]) => [v, k])
);

export const OUTPUT_ACTION_REVERSE_MAP = Object.fromEntries(
  Object.entries(OUTPUT_ACTION_MAP).map(([k, v]) => [v, k])
);

export const WIRELESS_CONTACT_REVERSE_MAP = Object.fromEntries(
  Object.entries(WIRELESS_CONTACT_MAP).map(([k, v]) => [v, k])
);

export const SUPERVISION_REVERSE_MAP = Object.fromEntries(
  Object.entries(SUPERVISION_MAP).map(([k, v]) => [v, k])
);

export const PIR_SENSITIVITY_REVERSE_MAP = Object.fromEntries(
  Object.entries(PIR_SENSITIVITY_MAP).map(([k, v]) => [v, k])
);

export const PET_IMMUNITY_REVERSE_MAP = Object.fromEntries(
  Object.entries(PET_IMMUNITY_MAP).map(([k, v]) => [v, k])
);

export const CHIME_SONG_REVERSE_MAP = Object.fromEntries(
  Object.entries(CHIME_SONG_MAP).map(([k, v]) => [v, k])
);

// Options for selects
export const ZONE_TYPE_OPTIONS = [
  { value: 'BLANK', text: 'Blank', code: '--' },
  { value: 'NIGHT', text: 'Night', code: 'NT' },
  { value: 'DAY', text: 'Day', code: 'DY' },
  { value: 'EXIT', text: 'Exit', code: 'EX' },
  { value: 'FIRE', text: 'Fire', code: 'FI' },
  { value: 'SUPERVISORY', text: 'Supervisory', code: 'SV' },
  { value: 'FIRE_VERIFY', text: 'Fire Verify', code: 'FV' },
  { value: 'PANIC', text: 'Panic', code: 'PN' },
  { value: 'ARMING', text: 'Arming', code: 'AR' },
  { value: 'AUXILIARY1', text: 'Auxiliary 1', code: 'A1' },
  { value: 'AUXILIARY2', text: 'Auxiliary 2', code: 'A2' },
  { value: 'EMERGENCY', text: 'Emergency', code: 'EM' },
  { value: 'INSTANT', text: 'Instant', code: 'IN' },
  { value: 'CARBONE_MONOXIDE', text: 'Carbone Monoxide', code: 'CO' },
  { value: 'DOOR_BELL', text: 'Doorbell', code: 'DB' },
];

export const MESSAGE_TYPE_OPTIONS = [
  { value: 'NONE', text: 'None', code: '--' },
  { value: 'ALARM', text: 'Alarm', code: 'A' },
  { value: 'TROUBLE', text: 'Trouble', code: 'T' },
  { value: 'LOCAL', text: 'Local', code: 'L' },
  { value: 'DOOR_PROPPED_OPEN', text: 'Door Propped Open', code: 'D' },
  { value: 'SENSOR_RESET', text: 'Sensor Reset', code: 'S' },
  { value: 'CANCEL_AMBUSH', text: 'Cancel Ambush', code: 'C' },
];

export const OUTPUT_ACTION_OPTIONS = [
  { value: 'NONE', text: 'None', code: '-' },
  { value: 'PULSE', text: 'Pulse', code: 'P' },
  { value: 'STEADY', text: 'Steady', code: 'S' },
  { value: 'MOMENTARY', text: 'Momentary', code: 'M' },
  { value: 'FOLLOW', text: 'Follow', code: 'F' },
];

export const WIRELESS_CONTACT_OPTIONS = [
  { value: 'EXTERNAL', text: 'External', code: '0' },
  { value: 'INTERNAL', text: 'Internal', code: '1' },
];

export const SUPERVISION_OPTIONS = [
  { value: 'NONE', text: 'None', code: '0' },
  { value: '3_MINUTES', text: '3 Minutes', code: '1' },
  { value: '60_MINUTES', text: '60 Minutes', code: '2' },
  { value: '240_MINUTES', text: '240 Minutes', code: '3' },
];

export const PIR_PULSE_COUNT_OPTIONS = [
  { value: '2', text: '2', code: '2' },
  { value: '4', text: '4', code: '4' },
];

export const PIR_SENSITIVITY_OPTIONS = [
  { value: 'LOW', text: 'Low', code: 'L' },
  { value: 'HIGH', text: 'High', code: 'H' },
];

export const PET_IMMUNITY_OPTIONS = [
  { value: 'ON', text: 'On', code: 'N' },
  { value: 'OFF', text: 'Off', code: 'F' },
];

export const CHIME_SONG_OPTIONS = [
  { value: 'OFF', text: 'Off', code: '0' },
  { value: 'DOOR_BELL', text: 'Door Bell', code: '1' },
  { value: 'DESCEND', text: 'Descend', code: '2' },
  { value: 'ASCEND', text: 'Ascend', code: '3' },
];

export const YES_NO_OPTIONS = [
  { value: 'Y', text: 'Yes' },
  { value: 'N', text: 'No' },
];

function normalizeReportWithAccountNumberFromBackend(value) {
  if (value === undefined || value === null || value === '') return '0';
  const asString = String(value);
  if (asString === '-' || asString === '00') return '0';
  return asString;
}

/**
 * Convierte datos del backend (GET) a formato de formulario legible
 */
export function mapZoneFromBackend(backendZone) {
  return {
    // Standard
    zoneNumber: parseInt(backendZone.zoneNumber),
    zoneName: backendZone.zoneName || '',
    zoneType: ZONE_TYPE_REVERSE_MAP[backendZone.zoneType] || 'BLANK',
    areaNumber: parseInt(backendZone.areaNumber, 10) || 0,
    followArea: backendZone.followArea || '',
    armedAreas: backendZone.armedAreas || '',
    expanderSerialNumber: backendZone.expanderSerialNumber || '',
    zoneLocation: backendZone.zoneLocation || '',

    // Action
    doMessage: MESSAGE_TYPE_REVERSE_MAP[backendZone.doMessage] || 'NONE',
    doOutputFireBell: parseInt(backendZone.doOutputFireBell) || '0',
    doOutputAction: OUTPUT_ACTION_REVERSE_MAP[backendZone.doOutputAction] || 'STEADY',
    dsMessage: MESSAGE_TYPE_REVERSE_MAP[backendZone.dsMessage] || 'NONE',
    dsOutput: parseInt(backendZone.dsOutput) || '0',
    dsOutputAction: OUTPUT_ACTION_REVERSE_MAP[backendZone.dsOutputAction] || 'STEADY',
    aoMessage: MESSAGE_TYPE_REVERSE_MAP[backendZone.aoMessage] || 'NONE',
    aoOutput: parseInt(backendZone.aoOutput) || '0',
    aoOutputAction: OUTPUT_ACTION_REVERSE_MAP[backendZone.aoOutputAction] || 'STEADY',
    asMessage: MESSAGE_TYPE_REVERSE_MAP[backendZone.asMessage] || 'NONE',
    asOutput: parseInt(backendZone.asOutput) || '0',
    asOutputAction: OUTPUT_ACTION_REVERSE_MAP[backendZone.asOutputAction] || 'STEADY',

    // Wireless
    wireless: backendZone.wireless === 'Y' ? 'Y' : 'N',
    dmpWirelessSerial: backendZone.dmpWireless || '00000000',
    dmpWirelessContact: WIRELESS_CONTACT_REVERSE_MAP[backendZone.dmpWirelessContact] || 'EXTERNAL',
    normallyOpen: backendZone.normallyOpen || 'Y',
    dmpWirelessSupervision: SUPERVISION_REVERSE_MAP[backendZone.dmpWirelessSupervision] || '240_MINUTES',
    ledOperation: backendZone.ledOperation || 'N',
    disarmDisable: backendZone.disarmDisable || 'N',
    dmpWirelessPirPulseCount: backendZone.dmpWirelessPirPulseCount || '4',
    dmpWirelessPirPulseSensitivity: PIR_SENSITIVITY_REVERSE_MAP[backendZone.dmpWirelessPirPulseSensitivity] || 'LOW',
    petImmunity: PET_IMMUNITY_REVERSE_MAP[backendZone.petImmunity] || 'OFF',

    // Advanced
    swingerBypass: backendZone.swingerBypass || 'N',
    zoneRetard: backendZone.zoneRetard || 'N',
    fastResponse: backendZone.fastResponse || 'N',
    crossZone: backendZone.crossZone || 'N',
    priority: backendZone.priority || 'N',
    firePanelSlaveInput: backendZone.firePanelSlaveInput || 'N',
    zoneRealTimeStatus: backendZone.zoneRealTimeStatus || 'Y',
    trafficCount: backendZone.trafficCount || 'Y',
    lockdown: backendZone.lockdown === 'Y' ? 'Y' : 'N',
    zoneAuditDays: backendZone.zoneAuditDays || '',
    reportWithAccountNumber: normalizeReportWithAccountNumberFromBackend(
      backendZone.reportWithAccountNumber
    ),
    chimeSong: CHIME_SONG_REVERSE_MAP[backendZone.chimeSong] || 'OFF',
    prewarPresignal: backendZone.prewarPresignal || '1-16',
    entryDelayNumber: backendZone.entryDelayNumber || '1',
  };
}

/**
 * Convierte datos del formulario a formato del backend (POST)
 * El backend espera recibir los valores legibles (NONE, STEADY, EXTERNAL, etc.)
 */
export function mapZoneToBackend(formZone) {
  return {
    // Standard
    zoneNumber: formatZoneNumber(formZone.zoneNumber),
    zoneName: (formZone.zoneName || '').toUpperCase().slice(0, 32),
    zoneType: formZone.zoneType || 'BLANK',
    areaNumber: String(formZone.areaNumber || 0).padStart(2, '0'),
    followArea: formZone.followArea || '',
    armedAreas: formZone.armedAreas || '',
    expanderSerialNumber: formZone.expanderSerialNumber || '',
    zoneLocation: formZone.zoneLocation || '',

    // Action
    doMessage: formZone.doMessage || 'NONE',
    doOutputFireBell: formatThreeDigits(formZone.doOutputFireBell),
    doOutputAction: formZone.doOutputAction || 'STEADY',
    dsMessage: formZone.dsMessage || 'NONE',
    dsOutput: formatThreeDigits(formZone.dsOutput),
    dsOutputAction: formZone.dsOutputAction || 'STEADY',
    aoMessage: formZone.aoMessage || 'NONE',
    aoOutput: formatThreeDigits(formZone.aoOutput),
    aoOutputAction: formZone.aoOutputAction || 'STEADY',
    asMessage: formZone.asMessage || 'NONE',
    asOutput: formatThreeDigits(formZone.asOutput),
    asOutputAction: formZone.asOutputAction || 'STEADY',

    // Wireless
    wireless: formZone.wireless === 'Y' ? 'Y' : 'N',
    dmpWirelessSerial: formatEightDigits(formZone.dmpWirelessSerial),
    dmpWirelessContact: formZone.dmpWirelessContact || 'EXTERNAL',
    normallyOpen: formZone.normallyOpen === 'Y' ? 'Y' : 'N',
    dmpWirelessSupervision: formZone.dmpWirelessSupervision || '240_MINUTES',
    ledOperation: formZone.ledOperation === 'Y' ? 'Y' : 'N',
    disarmDisable: formZone.disarmDisable === 'Y' ? 'Y' : 'N',
    dmpWirelessPirPulseCount: formZone.dmpWirelessPirPulseCount || '4',
    dmpWirelessPirPulseSensitivity: formZone.dmpWirelessPirPulseSensitivity || 'LOW',
    petImmunity: formZone.petImmunity || 'OFF',

    // Advanced
    swingerBypass: formZone.swingerBypass === 'Y' ? 'Y' : 'N',
    zoneRetard: formZone.zoneRetard === 'Y' ? 'Y' : 'N',
    fastResponse: formZone.fastResponse === 'Y' ? 'Y' : 'N',
    crossZone: formZone.crossZone === 'Y' ? 'Y' : 'N',
    priority: formZone.priority === 'Y' ? 'Y' : 'N',
    firePanelSlaveInput: formZone.firePanelSlaveInput === 'Y' ? 'Y' : 'N',
    zoneRealTimeStatus: formZone.zoneRealTimeStatus === 'Y' ? 'Y' : 'N',
    trafficCount: formZone.trafficCount === 'Y' ? 'Y' : 'N',
    lockdown: formZone.lockdown === 'Y' ? 'Y' : 'N',
    zoneAuditDays: formZone.zoneAuditDays || '',
    reportWithAccountNumber: (parseInt(formZone.reportWithAccountNumber, 10) || 0) === 0 ? '-' : String(parseInt(formZone.reportWithAccountNumber, 10)),
    chimeSong: formZone.chimeSong || 'OFF',
    prewarPresignal: formZone.prewarPresignal || '1-16',
    entryDelayNumber: String(formZone.entryDelayNumber || '1'),
  };
}

/**
 * Convierte datos del formulario a la forma GET (modo template).
 *
 * A diferencia de mapZoneToBackend (que envía valores legibles al POST), aquí
 * se reconstruye el shape EXACTO del GET: códigos cortos ("NT", "A", "F"),
 * claves del GET (dmpWireless, no dmpWirelessSerial) y el mismo formato de
 * números. Se hace spread del item original primero para conservar cualquier
 * clave que el formulario no modele.
 */
export function mapZoneToTemplate(formZone, original = {}) {
  return {
    ...original,
    // Standard
    zoneNumber: formatZoneNumber(formZone.zoneNumber),
    zoneName: (formZone.zoneName || '').toUpperCase().slice(0, 32),
    zoneType: ZONE_TYPE_MAP[formZone.zoneType] || '--',
    areaNumber:
      formZone.areaNumber === '' || formZone.areaNumber == null
        ? original.areaNumber || ''
        : String(parseInt(formZone.areaNumber, 10)).padStart(2, '0'),
    followArea: formZone.followArea || '0',
    armedAreas: formZone.armedAreas || '',
    expanderSerialNumber:
      formZone.expanderSerialNumber || original.expanderSerialNumber || '',

    // Action
    doMessage: MESSAGE_TYPE_MAP[formZone.doMessage] || '--',
    doOutputFireBell: formatThreeDigits(formZone.doOutputFireBell),
    doOutputAction: OUTPUT_ACTION_MAP[formZone.doOutputAction] || 'F',
    dsMessage: MESSAGE_TYPE_MAP[formZone.dsMessage] || '--',
    dsOutput: formatThreeDigits(formZone.dsOutput),
    dsOutputAction: OUTPUT_ACTION_MAP[formZone.dsOutputAction] || 'F',
    aoMessage: MESSAGE_TYPE_MAP[formZone.aoMessage] || '--',
    aoOutput: formatThreeDigits(formZone.aoOutput),
    aoOutputAction: OUTPUT_ACTION_MAP[formZone.aoOutputAction] || 'F',
    asMessage: MESSAGE_TYPE_MAP[formZone.asMessage] || '--',
    asOutput: formatThreeDigits(formZone.asOutput),
    asOutputAction: OUTPUT_ACTION_MAP[formZone.asOutputAction] || 'F',

    // Wireless
    wireless: formZone.wireless === 'Y' ? 'Y' : original.wireless || 'N',
    dmpWireless: formatEightDigits(formZone.dmpWirelessSerial),
    dmpWirelessContact: WIRELESS_CONTACT_MAP[formZone.dmpWirelessContact] || '0',
    normallyOpen: formZone.normallyOpen === 'Y' ? 'Y' : 'N',
    dmpWirelessSupervision:
      SUPERVISION_MAP[formZone.dmpWirelessSupervision] || '3',
    ledOperation: formZone.ledOperation === 'Y' ? 'Y' : 'N',
    disarmDisable: formZone.disarmDisable === 'Y' ? 'Y' : 'N',
    dmpWirelessPirPulseCount: formZone.dmpWirelessPirPulseCount || '4',
    dmpWirelessPirPulseSensitivity:
      PIR_SENSITIVITY_MAP[formZone.dmpWirelessPirPulseSensitivity] || 'L',
    petImmunity: PET_IMMUNITY_MAP[formZone.petImmunity] || 'F',

    // Advanced
    swingerBypass: formZone.swingerBypass === 'Y' ? 'Y' : 'N',
    zoneRetard: formZone.zoneRetard === 'Y' ? 'Y' : 'N',
    fastResponse: formZone.fastResponse === 'Y' ? 'Y' : 'N',
    crossZone: formZone.crossZone === 'Y' ? 'Y' : 'N',
    priority: formZone.priority === 'Y' ? 'Y' : 'N',
    firePanelSlaveInput: formZone.firePanelSlaveInput === 'Y' ? 'Y' : 'N',
    zoneRealTimeStatus: formZone.zoneRealTimeStatus === 'Y' ? 'Y' : 'N',
    trafficCount: formZone.trafficCount === 'Y' ? 'Y' : 'N',
    lockdown: formZone.lockdown === 'Y' ? 'Y' : 'N',
    zoneAuditDays: formZone.zoneAuditDays || '0',
    reportWithAccountNumber:
      (parseInt(formZone.reportWithAccountNumber, 10) || 0) === 0
        ? '00'
        : String(parseInt(formZone.reportWithAccountNumber, 10)).padStart(
            2,
            '0'
          ),
    chimeSong: CHIME_SONG_MAP[formZone.chimeSong] || '0',
    prewarPresignal: formZone.prewarPresignal || '1-16',
    entryDelayNumber: String(formZone.entryDelayNumber || '1'),
  };
}

/**
 * Formatea número de zona a 3 dígitos
 */
export function formatZoneNumber(value) {
  if (!value && value !== 0) return '001';
  const num = String(value).padStart(3, '0');
  return num.slice(0, 3);
}


/**
 * Formatea valor a 3 dígitos
 */
export function formatThreeDigits(value) {
  if (!value && value !== 0) return '000';
  const num = String(value).padStart(3, '0');
  return num.slice(0, 3);
}

/**
 * Formatea valor a 2 dígitos
 */
export function formatTwoDigits(value) {
  if (!value && value !== 0) return '00';
  const num = String(value).padStart(2, '0');
  return num.slice(0, 2);
}

/**
 * Formatea valor a 8 dígitos
 */
export function formatEightDigits(value) {
  if (!value && value !== 0) return '00000000';
  const num = String(value).padStart(8, '0');
  return num.slice(0, 8);
}

/**
 * Formatea valor de rango (ejemplo: "01", "1-32")
 */
export function formatRangeValue(value, digits = 2) {
  if (!value) return '0'.repeat(digits);
  return String(value).padStart(digits, '0');
}

/**
 * Obtiene valores por defecto para una nueva zona
 */
export function getDefaultZoneValues() {
  return {
    // Standard
    zoneNumber: null,
    zoneName: '',
    zoneType: 'BLANK',
    areaNumber: 1,
    followArea: '0',
    armedAreas: '',
    expanderSerialNumber: '',
    zoneLocation: '',

    // Action
    doMessage: 'NONE',
    doOutputFireBell: '0',
    doOutputAction: 'STEADY',
    dsMessage: 'NONE',
    dsOutput: '0',
    dsOutputAction: 'STEADY',
    aoMessage: 'NONE',
    aoOutput: '0',
    aoOutputAction: 'STEADY',
    asMessage: 'NONE',
    asOutput: '0',
    asOutputAction: 'STEADY',

    // Wireless
    wireless: 'N',
    dmpWirelessSerial: '',
    dmpWirelessContact: 'INTERNAL',
    normallyOpen: 'Y',
    dmpWirelessSupervision: '240_MINUTES',
    ledOperation: 'N',
    disarmDisable: 'N',
    dmpWirelessPirPulseCount: '4',
    dmpWirelessPirPulseSensitivity: 'LOW',
    petImmunity: 'OFF',

    // Advanced
    swingerBypass: 'N',
    zoneRetard: 'N',
    fastResponse: 'N',
    crossZone: 'N',
    priority: 'N',
    firePanelSlaveInput: 'N',
    zoneRealTimeStatus: 'N',
    trafficCount: 'N',
    lockdown: 'N',
    zoneAuditDays: '',
    reportWithAccountNumber: '',
    chimeSong: 'OFF',
    prewarPresignal: '1-16',
    entryDelayNumber: '1',
  };
}
